export default {"src":"/_next/static/media/amenities.eaf2afca.svg","height":23,"width":32,"blurWidth":0,"blurHeight":0};